import { FontAwesome as Icon } from "@expo/vector-icons";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  StyleProp,
  StyleSheet,
  TextInput,
  TextInputProps,
  TouchableOpacity,
  ViewStyle,
} from "react-native";
import { ThemedView } from "../ThemedView";

interface PasswordInputProps extends TextInputProps {
  value: string;
  onChangeText: (text: string) => void;
  containerStyle?: StyleProp<ViewStyle>;
}

const PasswordInput: React.FC<PasswordInputProps> = ({
  value,
  onChangeText,
  containerStyle,
  ...props
}) => {
  const { t } = useTranslation();

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  return (
    <ThemedView style={[styles.container, containerStyle]}>
      <TextInput
        style={styles.input}
        placeholder={t("PASSWORD")}
        value={value}
        onChangeText={onChangeText}
        secureTextEntry={!isPasswordVisible}
        placeholderTextColor="#888"
        {...props}
      />
      <TouchableOpacity
        onPress={togglePasswordVisibility}
        style={styles.iconContainer}
        accessibilityRole="button"
        accessibilityLabel={
          isPasswordVisible ? t("HIDE_PASSWORD") : t("SHOW_PASSWORD")
        }
      >
        <Icon
          name={isPasswordVisible ? "eye" : "eye-slash"}
          size={20}
          color="#888"
        />
      </TouchableOpacity>
    </ThemedView>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    position: "relative",
    width: "100%",
    maxWidth: 320,
    borderColor: "#ccc",
    borderWidth: 1,
    borderRadius: 8,
    backgroundColor: "#fafafa",
    marginBottom: 20,
  },
  input: {
    height: 48,
    fontSize: 16,
    color: "#000",
    paddingLeft: 12,
    paddingRight: 44,
    width: "100%",
  },
  iconContainer: {
    position: "absolute",
    right: 10,
    top: 0,
    bottom: 0,
    justifyContent: "center",
    alignItems: "center",
    width: 36,
  },
});

export default PasswordInput;
